import React from 'react';
import { CommonIconProps } from './Icon';

function ConnectorIcon({ color }: CommonIconProps): JSX.Element {
  return (
    <>
      <circle opacity="0.15" cx="4" cy="12" r="2" fill={color} />
      <circle opacity="0.3" cx="12" cy="12" r="2" fill={color} />
      <circle opacity="0.45" cx="20" cy="12" r="2" fill={color} />
    </>
  );
}

export default ConnectorIcon;
